// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f992e0ae","732":"17587588"}[chunkId] + ".chunk.js";
};